__turbopack_context__.v({
  "borderTop": "_1tmo5W_borderTop",
  "borderTopNone": "_1tmo5W_borderTopNone",
  "container": "_1tmo5W_container",
  "desktopMainLink": "_1tmo5W_desktopMainLink",
  "desktopSubMenuBtn": "_1tmo5W_desktopSubMenuBtn",
  "enLangButtonStyles": "_1tmo5W_enLangButtonStyles",
  "hamMenuWrapper": "_1tmo5W_hamMenuWrapper",
  "logoContainer": "_1tmo5W_logoContainer",
  "logoContainerTitle": "_1tmo5W_logoContainerTitle",
  "logoContainerVerticalLine": "_1tmo5W_logoContainerVerticalLine",
  "mainMenuBtn": "_1tmo5W_mainMenuBtn",
  "menuContainer": "_1tmo5W_menuContainer",
  "mobileMainMenuBtn": "_1tmo5W_mobileMainMenuBtn",
  "mobileSubMenuBtn": "_1tmo5W_mobileSubMenuBtn",
  "mobileSubMenuBtnTitle": "_1tmo5W_mobileSubMenuBtnTitle",
  "mobileSubMenuContainer": "_1tmo5W_mobileSubMenuContainer",
  "rightArrowTitlSubStyles": "_1tmo5W_rightArrowTitlSubStyles",
  "searchBtn": "_1tmo5W_searchBtn",
  "secondContainerBg": "_1tmo5W_secondContainerBg",
  "secondLogoContainerVerticalLine": "_1tmo5W_secondLogoContainerVerticalLine",
  "subMenuContainer": "_1tmo5W_subMenuContainer",
});
